// extracted by mini-css-extract-plugin
module.exports = {"badge":"StyledBadge_badge___T7cm","badgeImage":"StyledBadge_badgeImage__C1PTe","badgeText":"StyledBadge_badgeText__lMAVY","commonBadgeText":"StyledBadge_commonBadgeText__Zl3Qk"};